import authenticatedFetch from '@/utils/authenticatedApiClient.js';
import { normalizeCommunityIdentityStatus } from '@/lib/communityIdentityContract.js';

const DEFAULT_ERROR_CODE = 'community_identity_request_failed';

export class CommunityIdentityRequestError extends Error {
  constructor(
    message,
    {
      code = DEFAULT_ERROR_CODE,
      status = 500,
      communityIdentity = null,
    } = {},
  ) {
    super(message);
    this.name = 'CommunityIdentityRequestError';
    this.code = code;
    this.status = status;
    this.communityIdentity = communityIdentity;
  }
}

const parsePayload = async (response) => {
  const rawText = await response.text();
  if (!rawText) {
    return {};
  }

  try {
    return JSON.parse(rawText);
  } catch {
    throw new CommunityIdentityRequestError(
      'La risposta dell’identità community non è valida.',
      {
        code: 'community_identity_invalid_response',
        status: response.status || 500,
      },
    );
  }
};

const requestCommunityIdentity = async (init) => {
  const response = await authenticatedFetch('/api/account/community-identity', init);
  const payload = await parsePayload(response);

  if (!response.ok) {
    const communityIdentity = payload?.communityIdentity
      ? normalizeCommunityIdentityStatus(payload.communityIdentity)
      : null;
    throw new CommunityIdentityRequestError(
      payload?.message || 'Impossibile gestire l’identità community.',
      {
        code: payload?.error || DEFAULT_ERROR_CODE,
        status: response.status || 500,
        communityIdentity,
      },
    );
  }

  if (!payload?.communityIdentity || typeof payload.communityIdentity !== 'object') {
    throw new CommunityIdentityRequestError(
      'Stato dell’identità community mancante.',
      {
        code: 'community_identity_invalid_response',
        status: response.status || 500,
      },
    );
  }

  return normalizeCommunityIdentityStatus(payload.communityIdentity);
};

export const fetchCommunityIdentity = async () =>
  requestCommunityIdentity({ method: 'GET' });

export const completeCommunityIdentity = async ({
  handle,
  ageConfirmed,
} = {}) =>
  requestCommunityIdentity({
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      handle: typeof handle === 'string' ? handle.trim() : '',
      ageConfirmed: ageConfirmed === true,
    }),
  });
